export const defaultProfile = {
  demographics: {},
  initialChart: { triage: '', disclosedAtStart: [], vitals: [] },
  labs: {}
};

// All patient-specific content comes from the backend's allowlisted student
// profile. Stale hardcoded case data and browser-local instructor edits must
// never replace the authoritative scenario.
export function getCaseProfile(caseItem) {
  const profile = caseItem?.student_profile;
  if (!profile || typeof profile !== 'object') return defaultProfile;
  return {
    demographics: profile.demographics || {},
    initialChart: {
      ...defaultProfile.initialChart,
      ...(profile.initialChart || {})
    },
    labs: {}
  };
}

export function getLocalizedCaseDisplay(caseItem) {
  if (!caseItem) return null;
  const profile = getCaseProfile(caseItem);
  return {
    ...caseItem,
    chiefComplaint: caseItem.chiefComplaint ?? caseItem.chief_complaint ?? '',
    triage: profile.initialChart.triage || caseItem.triage || '',
    gender: profile.demographics.sex || caseItem.gender || '',
    setting: profile.demographics.setting || caseItem.setting || ''
  };
}
